// 会聊消息查询需要“响应结束后再等待”的串行节奏，不能使用会造成慢请求并发的 setInterval。
export const createConferenceChatPolling = (
  refresh: () => Promise<void>,
  intervalMs: number,
  onError?: (error: unknown) => void
) => {
  let active = false;
  let timer: ReturnType<typeof setTimeout> | undefined;

  const run = async () => {
    if (!active) {
      return;
    }
    try {
      await refresh();
    } catch (error) {
      // 单次失败不终止后续刷新，具体日志或上报交由页面调用方决定。
      onError?.(error);
    } finally {
      // 仅在本次查询结束后计时，避免慢请求造成并发轮询。
      if (active) {
        timer = setTimeout(() => {
          timer = undefined;
          void run();
        }, intervalMs);
      }
    }
  };

  return {
    start: (options?: { delayed?: boolean }) => {
      if (active) {
        return;
      }
      active = true;
      if (options?.delayed) {
        // 页面已自行完成首次加载时，先等待一个完整周期，避免与首次请求并发。
        timer = setTimeout(() => {
          timer = undefined;
          void run();
        }, intervalMs);
        return;
      }
      void run();
    },
    stop: () => {
      active = false;
      // 清除尚未触发的定时器；已在执行的请求无法中断，但结束后不会再排下一次。
      if (timer) {
        clearTimeout(timer);
        timer = undefined;
      }
    },
  };
};
